import { render, staticRenderFns } from "./MobileLineDiyQuotation.vue?vue&type=template&id=223f0b59&scoped=true&"
import script from "./MobileLineDiyQuotation.vue?vue&type=script&lang=js&"
export * from "./MobileLineDiyQuotation.vue?vue&type=script&lang=js&"
import style0 from "./MobileLineDiyQuotation.vue?vue&type=style&index=0&id=223f0b59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223f0b59",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDataTable,VDivider,VRow})
